/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {GameInterface, ResizeImageConfiguration} from '@/store/modules/games/types';

const namespace: string = 'gamesStateModule';

/**
 * GamesFilter component.
 *
 * @author jgeorgiadou@frontier.co.uk
 */
@Component({
    name: 'c-games-filter',
})
export default class GamesFilter extends Vue {
    // Games
    @Action('fetchGames', {namespace})
    public fetchGames: any;
    @Action('updateCurrentGame', {namespace})
    public updateCurrentGame: any;
    @Getter('getCurrentGame', {namespace})
    public getCurrentGame!: GameInterface;
    @Getter('getGames', {namespace})
    public getGames!: GameInterface[];
    // Settings masthead
    @Action('updateMastheadImage', {namespace: 'settingsModule'})
    public updateMastheadImage!: (imageSlug: string | undefined) => void;
    // Settings background image
    @Action('updateBackgroundImage', {namespace: 'settingsModule'})
    public updateBackgroundImage!: (imageSlug: string | undefined) => void;

    /**
     * Mounted life-cycle event.
     */
     public async mounted(): Promise<void> {
         await this.fetchGames();
    }

    /**
     * Destroyed lifecycle hook
     */
    public destroyed(): void {
        this.updateMastheadImage(undefined);
    }

    /**
     * Update game, push to route and scroll to list.
     */
    public selectGame(game: GameInterface): void {
        this.updateCurrentGame(game);
        if (typeof game.key_art !== 'undefined' && game.key_art != null) {
             this.updateMastheadImage(this.getImageUrl(game.key_art, {width: 1920, height: 640, fit: 'cover' }));
             this.updateBackgroundImage(this.getImageUrl(game.key_art, {width: 1280, height: 720, fit: 'cover' }));
        }
        this.$router.push({name: 'reported-issues-game-slug', params: {gameSlug: game.slug}});
    }

    /**
     * Generate image url
     *
     * @param gameKeyArt
     * @param config
     */
    public getImageUrl(gameKeyArt: string, config: ResizeImageConfiguration): string {
        const gameKey: string = gameKeyArt.replace(/https\:\/\/cms-cdn(-[a-z]+)?\.zaonce\.net\//i, '');
        const imageRequest: string = JSON.stringify({
            bucket: 'frontier-cms',
            key: gameKey,
            edits: {
                resize: config,
            },
        });

        return `https://d1zb04s4od4oai.cloudfront.net/${btoa(imageRequest)}`;
    }

    /**
     * Background styles
     * @param {string} keyArtUrl
     * @return {string}
     */
    public getBackgroundStyles(keyArtUrl: string): string {
        return  'background-image: ' + 'url("' + keyArtUrl + '");';
    }

}
